import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SequenceCardComponent } from './sequence-card/sequence-card.component';
import { SharedModule } from '@shared/modules/shared.module';
import { DutyInfoDialogComponent } from './sequence-card/duty-info-dialog/duty-info-dialog.component';
import { PayInfoDialogComponent } from './sequence-card/pay-info-dialog/pay-info-dialog.component';
import { SeqTotalDialogComponent } from './sequence-card/seq-total-dialog/seq-total-dialog.component';
import { HotelModule } from '@shared/features/hotel/hotel.module';

@NgModule({
  declarations: [
    SequenceCardComponent,
    DutyInfoDialogComponent,
    PayInfoDialogComponent,
    SeqTotalDialogComponent,
  ],
  imports: [CommonModule, SharedModule, HotelModule],
  exports: [SequenceCardComponent],
})
export class SequenceModule {}
